import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

function PaymentSuccess() {
  const navigate = useNavigate();

  useEffect(() => {
    window.history.pushState(null, "", window.location.href);

    const handlePopState = () => {
      navigate("/transactions", { replace: true, state: { qr_login_completed: 1 } });
    };

    window.addEventListener("popstate", handlePopState);

    const timer = setTimeout(() => {
      navigate("/transactions", { replace: true });
    }, 5000);

    return () => {
      window.removeEventListener("popstate", handlePopState);
      clearTimeout(timer);
    };
  }, [navigate]);

  return (
    <div
      className="min-h-screen flex items-center justify-center"
      style={{
        backgroundColor: '#ffffff',
        backgroundImage: `
          linear-gradient(
            180deg,
            rgba(248, 250, 252, 1) 0%,
            rgba(239, 246, 255, 0.3) 50%,
            rgba(238, 242, 255, 0.4) 100%
          )
        `,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
      }}
    >
      <div className="flex flex-col items-center justify-center gap-3">
        <div className="w-16 h-16 bg-[#4CAF50] rounded-full flex items-center justify-center shadow-md">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="white"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="w-7 h-7"
          >
            <polyline points="20 6 9 17 4 12" />
          </svg>
        </div>

        <h1 className="text-[#394784] text-[24px] font-bold text-center mt-2 leading-[150%] tracking-[0px]">
          Your Payment is in process
        </h1>

        <p className="text-[#676F7D] text-[16px] font-medium text-center leading-[100%] tracking-[0%] font-inter">
          Redirecting To Home....
        </p>
      </div>
    </div>
  );
}

export default PaymentSuccess;